import { adTechLog } from './log';

let loggedOnDOMLoaded = false,
	loggedOnDOMComplete = false;

/** Function for on DOM loaded.
 *
 * @param {function} callback A callback function to run.
 * @param {null|undefined|Object} params Optional params to run with the callback function.
 */
export const onDOMLoad = ( callback, params = null ) => {
	const callbackFunc = () => {
		if ( 'function' === typeof callback ) {
			'undefined' === typeof params || null === params ? callback() : callback( params );
		}
	}

	if ( document.readyState !== 'loading' ) {
		if ( ! loggedOnDOMLoaded ) {
			loggedOnDOMLoaded = true;

			// Log the event.
			adTechLog( {
				type: 'event',
				message: 'DOMLoad: document readyState !== \'loading\'',
			} );
		}
		// Document is already ready, call the callback directly
		callbackFunc();

	} else if ( document.addEventListener ) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener(
			'DOMContentLoaded',
			function() {
				if ( ! loggedOnDOMLoaded ) {
					loggedOnDOMLoaded = true;

					// Log the event.
					adTechLog( {
						type: 'event',
						message: 'DOMLoad: document \'DOMContentLoaded\' event triggered',
					} );
				}
				callbackFunc()
			}
		);
	} else {
		// Old IE browsers
		document.attachEvent( 'onreadystatechange', function() {
			if ( document.readyState !== 'loading' ) {
				if ( ! loggedOnDOMLoaded ) {
					loggedOnDOMLoaded = true;

					// Log the event.
					adTechLog( {
						type: 'event',
						message: 'DOMLoad: event onreadystatechange, document.readyState !== \'loading\'',
					} );
				}
				callbackFunc();
			}
		} );
	}
}

/**
 * Function for on DOM complete.
 *
 * @param {function} callback A callback function to run.
 * @param {null|undefined|Object} params Optional params to run with the callback function.
 */
export const onDOMComplete = ( callback, params = null ) => {
	const callbackFunc = () => {
		if ( 'function' === typeof callback ) {
			'undefined' === typeof params || null === params ? callback() : callback( params );
		}
	}

	if ( document.readyState === 'complete' ) {
		if ( ! loggedOnDOMComplete ) {
			loggedOnDOMComplete = true;

			// Log the event.
			adTechLog( {
				type: 'event',
				message: 'onDOMComplete: document readyState === \'complete\'',
			} )
		}
		// Document is already ready, call the callback directly
		callbackFunc();
	} else if ( window.addEventListener ) {
		// All modern browsers to register DOMContentLoaded
		window.addEventListener(
			'load',
			function() {
				if ( ! loggedOnDOMComplete ) {
					loggedOnDOMComplete = true;

					// Log the event.
					adTechLog( {
						type: 'event',
						message: 'onDOMComplete: window \'load\' event triggered',
					} );
				}
				callbackFunc()
			}
		);

	} else {
		// Old IE browsers
		document.attachEvent( 'onreadystatechange', function() {
			if ( document.readyState === 'complete' ) {
				if ( ! loggedOnDOMComplete ) {
					loggedOnDOMComplete = true;

					// Log the event.
					adTechLog( {
						type: 'event',
						message: 'onDOMComplete: event onreadystatechange, document.readyState === \'complete\'',
					} );
				}
				callbackFunc();
			}
		} );
	}
}